// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Form__question___1Og60{display:inline-block;margin-bottom:5px}.Form__answer___2q39F{margin-bottom:20px}", ""]);
// Exports
exports.locals = {
	"question": "Form__question___1Og60",
	"answer": "Form__answer___2q39F"
};
module.exports = exports;
